export default "/imgs/bnr-2.jpg"